module.exports = __webpack_public_path__ + "route-template.xlsx";